import {useToastStore} from './useToastStore';
import {
  Toast,
  TOAST_POSITIONS,
  TOAST_VISIBILITY_DURATIONS,
  BUTTON_VARIANTS,
  BUTTON_ICON_COLORS,
  IconCancelOutlined,
} from 'cdk-radial';

const ToastContainer = () => {
    const { isOpen, message, resetToast, type, id } = useToastStore();

      return (<>
      {isOpen && (
              <Toast
                id={id}
                datatestid={id}
                position={TOAST_POSITIONS.FIXED}
                style={{
                  marginTop: '70px',
                  zIndex: 1003,
                }}
                variant={type === 'Error' ? 'negative' : 'positive'}
                visibilityDuration={TOAST_VISIBILITY_DURATIONS.SIX_SECONDS}
                onVisibilityDurationEnd={() => {
                  resetToast();
                }}
                actions={[
                  {
                    onClick: () => {
                      resetToast();
                    },
                    variant: BUTTON_VARIANTS.ICON,
                    icon: <IconCancelOutlined />,
                    iconColor: BUTTON_ICON_COLORS.GRAY,
                    text: '',
                  },
                ]}
                content={message}
              />
            )}
      </>)

};

export default ToastContainer;